import React from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import * as yup from "yup";

import { Button } from "./ui/button";

import { HookInput as Input, DatePicker } from "../helpers/formHelpers";

const FiringForm = ({ initialValues, onSubmit }: { initialValues: any; onSubmit: any }) => {
  const schema = yup.object().shape({
    name: yup.string().required(),
  });

  const { control, handleSubmit, formState } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialValues,
  });
  const { errors } = formState;

  return (
    <div className="border rounded-lg p-4">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          control={control as any}
          errors={errors}
          name="name"
          label="Firing Name"
          errorMessage={errors.name ? "This field is required" : undefined}
        />
        <DatePicker
          control={control as any}
          name="date"
          label="Firing Date"
        />
        <Input
          control={control as any}
          errors={errors}
          name="notes"
          label="Notes"
          errorMessage={errors.name ? "This field is required" : undefined}
          multiline={true}
          numberOfLines={8}
        />
        <Button
          variant="outline"
          onClick={handleSubmit(onSubmit)}
          disabled={!formState.isDirty || formState.isSubmitting}
        >
          Update
        </Button>
      </form>
    </div>
  );
};

export default FiringForm;
